import apiService from './apiService';

const PREFIX = '/admin/client-propositions';

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res.data;
}

const clientPropositionService = {
  async list({ source = '', q = '', limit = 200 } = {}) {
    const data = await request(apiService.get(PREFIX, { source, q, limit }));
    return {
      propositions: Array.isArray(data.propositions) ? data.propositions : [],
      counts: data.counts || { hubspot: 0, rag: 0, high_score: 0 },
    };
  },

  async proposer(source = 'tous') {
    const data = await request(apiService.post(`${PREFIX}/proposer`, { source }, {}, { timeout: 300000 }));
    return data.stats || {};
  },

  async accept(id) {
    return request(apiService.post(`${PREFIX}/${id}/accepter`));
  },

  async reject(id) {
    return request(apiService.post(`${PREFIX}/${id}/rejeter`));
  },

  async acceptLot({ source = '', minScore = 0.95 } = {}) {
    const data = await request(apiService.post(`${PREFIX}/accepter-lot`, {
      source: source || undefined,
      min_score: minScore,
    }));
    return data.stats || {};
  },

  async searchSource(source, q = '', limit = 15) {
    const data = await request(apiService.get(`${PREFIX}/sources/${source}`, { q, limit }));
    return Array.isArray(data.results) ? data.results : [];
  },
};

export default clientPropositionService;
